import {getLayoutData, getPageData} from "@/pages/api/api";
import styled from "styled-components";
import Container from "@/components/common/Container";
import {useBranch} from "@/hooks/useBranch";
import {useRouter} from "next/router";
import {SINGLE_PAGE_QUERY} from "@/pages/api/fragments";
import useSetBannerData from "@/hooks/useSetBannerData";
import ExtendedContent from "@/components/common/ExtendedContent";
import {useTransformedMenuContext} from "@/layout/Layout";
import {useMemo} from "react";
import {formatToCardItem} from "@/components/common/Cards";
import ListCards from "@/components/common/Cards/List";
import {PAGES, SINGLE_PAGE_TYPES} from "@/constants";

const StyledLookingForHelp = styled(Container)`
	padding: 100px 0;
	h1, a {
		color: ${({theme}) => theme.colors.white};
		span {
			color: ${({theme}) => theme.colors.pennRed};
		}
	}
	img {
		max-width: 100%;
		object-fit: contain;
	}
`


export default function Others({data, locale, menu}) {
	const router = useRouter();
	const pageName = data?.pageName || '';
	const slug = data?.slug || '';
	const { selectedOption} = useBranch();
	const content = data?.content || []
	const bannerData = useSetBannerData(data)
	const transformedMenuData = useTransformedMenuContext('menuData');
	const currentData = useMemo(
		() => transformedMenuData.find(({ universalLink }) => universalLink.link.link.id === data.id),
		[data.id, transformedMenuData]
	);

	const formattedCardsData = useMemo(() => {
		return currentData?.children
			?.filter(({ universalLink }) => universalLink?.link?.link?.card)
			.map(({ universalLink }) => formatToCardItem(universalLink.link.link)) || [];
	}, [currentData]);

	return(
		<>
			<ExtendedContent content={content} globalBannerData={bannerData} />
			<Container>
				<ListCards data={formattedCardsData} noDateColumn mobileSliderEnabled={false}/>
			</Container>
		</>
	)
}

const OTHERS_PAGE_QUERY = `
	query GetOthersPageData($locale: SiteLocale) {
		allSinglePages(locale: $locale,  filter: {slug: {eq: "${PAGES.OTHERS}"}, pageType: {eq: "${SINGLE_PAGE_TYPES.OTHERS}"}}) {
			__typename
			${SINGLE_PAGE_QUERY}
		}
	}
`;

export async function getStaticProps(context) {
	const locale = context?.locale || 'pl';
	const data = await getPageData('allSinglePages', PAGES.OTHERS, OTHERS_PAGE_QUERY, locale);
	const layout= await getLayoutData(locale)
	return {
		props: {
			data,
			locale,
			...layout,
			isDarkSearch: true
		},
		revalidate: 60 * 60
	};
}
